import {
  CardWithIcon,
  Heading,
  SvgIconProps,
  Text,
} from '@cinch-labs/design-system'
import React from 'react'

import styles from './feature-card.module.css'

export type FeatureCardProps = {
  title: string
  body: string
  icon: SvgIconProps['name']
}

export const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  body,
  icon,
}) => (
  <div className={styles.container} data-testid="feature-card">
    <CardWithIcon
      className={styles.card}
      iconName={icon}
      iconColor="vividViolet"
      iconGradient="galaxy"
      iconSize={32}
    />
    <Heading element="h3" className={styles.title}>
      {title}
    </Heading>
    <Text className={styles.body}>{body}</Text>
  </div>
)
